import { z } from 'zod';
import { zDocument, expectType } from './model.js';
import { reverseKeys } from './util/reverseKeys.js';
const ItemFields = z.object({
    type: z.literal('item'),
    name: z.string(),
    description: z.string().optional(),
    price: z.string().optional(),
    image: z.string().optional()
});
export const BusinessTypeLookup = {
    '': 'None',
    grocery: 'Grocery',
    retail: 'Shop / Retail',
    fooddrink: 'Food and Drink',
    service: 'Service / Repair',
    education: 'Educational',
    personal: 'Personal Care',
    giving: 'Giving / Charity / Non-profit'
};
export const AllowedBusinessTypes = Object.entries(BusinessTypeLookup).reduce((accum, [key, value]) => {
    if (key !== '') {
        accum[key] = value;
    }
    return accum;
}, {});
export const BusinessStatusLookup = {
    open: 'Open',
    online: 'Online',
    closed: 'Closed'
};
export const BusinessServiceLookup = {
    curbside: 'Curbside',
    delivery: 'Delivery',
    takeout: 'Takeout',
    giftcard: 'Giftcard',
    service: 'Service',
    retail: 'Retail',
    online: 'Online'
};
export const DeliveryType = {
    direct: 'Direct',
    grubhub: 'GrubHub',
    postmates: 'Postmates',
    curbside: 'Curbside Pickup',
    doordash: 'Doordash',
    ubereats: 'Uber Eats',
    chownow: 'ChowNow',
    instacart: 'Instacart',
    other: 'Other'
};
export const BUSINESS_CLAIM_STATUSES = ['claimed', 'pending', 'unclaimed'];
export const BUSINESS_APPROVAL_STATUSES = ['approved', 'pending', 'rejected'];
export const BusinessTypeEnum = z.nativeEnum(reverseKeys(BusinessTypeLookup));
export const BusinessStatusEnum = z.nativeEnum(reverseKeys(BusinessStatusLookup));
export const BusinessServicesEnum = z.nativeEnum(reverseKeys(BusinessServiceLookup));
export const DeliveryServicesEnum = z.nativeEnum(reverseKeys(DeliveryType));
export const zBusiness = zDocument.extend({
    type: z.literal('business'),
    businessType: BusinessTypeEnum,
    owner: z.string(),
    claimStatus: z.enum(BUSINESS_CLAIM_STATUSES),
    submissionStatus: z.enum(BUSINESS_APPROVAL_STATUSES).or(z.literal('')),
    name: z.string(),
    description: z.string(),
    address: z.string(),
    city: z.string(),
    district: z.string(),
    services: z.array(BusinessServicesEnum),
    status: BusinessStatusEnum,
    delivery: z.array(DeliveryServicesEnum),
    otherDelivery: z.string(),
    patio: z.boolean(),
    phone: z.string(),
    hours: z.string(),
    items: z.array(ItemFields),
    website: z.string(),
    email: z.string(),
    logoURL: z.string(),
    bannerURL: z.string(),
    logo: z.string(),
    banner: z.string(),
    stars: z.number(),
    draft: z.boolean(),
    logoBackgroundColor: z.string(),
    submittedBy: z.string()
});
// Validate zod schema matches
expectType({});
expectType({});
export const EmptyNewBusiness = {
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    type: 'business',
    businessType: BusinessTypeEnum.enum['Giving / Charity / Non-profit'],
    owner: '',
    name: '',
    description: '',
    address: '',
    city: '',
    district: '',
    services: [],
    status: 'open',
    delivery: [],
    otherDelivery: '',
    patio: false,
    phone: '',
    hours: '',
    items: [],
    website: '',
    email: '',
    logoURL: '',
    bannerURL: '',
    logo: '',
    banner: '',
    stars: 0,
    draft: false,
    logoBackgroundColor: '',
    claimStatus: 'unclaimed',
    submissionStatus: '',
    submittedBy: ''
};
export const EmptyBusiness = {
    ...EmptyNewBusiness,
    businessType: ''
};
